/**
 * Maps a raw verified/required ratio to a snapped visual reveal percentage.
 * Returns a value in [0, 1].
 *
 * @param {number} verified
 * @param {number} required
 * @returns {number}
 */
export function getRevealPercent(verified, required) {
    if (required === 0) return 1;
    const raw = verified / required;
    if (raw === 0)    return 0.04;   // barely-visible silhouette
    if (raw <= 0.25)  return 0.22;   // bottom quarter revealed
    if (raw <= 0.5)   return 0.45;   // approaching halfway
    if (raw <= 0.75)  return 0.68;   // past halfway
    if (raw < 1)      return 0.88;   // almost there
    return 1;                         // fully revealed
}